import type { ReactNode } from 'react';
import { CalloutTemplate } from 'v5/features/callouts/callout-templates';

const LEADING_EMOJI_RE =
  /^(\p{RI}\p{RI}|\p{Extended_Pictographic}(?:\p{Emoji_Modifier}|\uFE0F|\u200D\p{Extended_Pictographic})*)\s*/u;

export function splitCalloutTemplateName(name: string): {
  icon: string | null;
  label: string;
} {
  const match = name.match(LEADING_EMOJI_RE);
  if (!match) {
    return { icon: null, label: name };
  }
  return {
    icon: match[1],
    label: name.slice(match[0].length).trim()
  };
}

export function getCalloutTemplateIcon(template: CalloutTemplate): ReactNode {
  const { icon } = splitCalloutTemplateName(template.name);
  if (!icon) {
    return null;
  }
  return <span className="text-2xl leading-none">{icon}</span>;
}

export function getCalloutTemplateLabel(template: CalloutTemplate): string {
  return splitCalloutTemplateName(template.name).label;
}
